/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AddKartePlannerCommentTemplateInput = {
  body: string;
  label: string;
  selections: Array<string>;
};

export type UpdateKartePlannerCommentTemplateInput = {
  body: string;
  id: string | number;
  label: string;
  selections: Array<string>;
};

export type FetchKartePlannerCommentTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchKartePlannerCommentTemplateQuery = { viewer: { kartePlannerCommentTemplates: Array<{ id: string, label: string, body: string, selections: Array<string> }> } };

export type AddKartePlannerCommentTemplateMutationVariables = Exact<{
  input: Types.AddKartePlannerCommentTemplateInput;
}>;


export type AddKartePlannerCommentTemplateMutation = { addKartePlannerCommentTemplate: Array<{ id: string, label: string, body: string, selections: Array<string> }> };

export type UpdateKartePlannerCommentTemplateMutationVariables = Exact<{
  input: Types.UpdateKartePlannerCommentTemplateInput;
}>;


export type UpdateKartePlannerCommentTemplateMutation = { updateKartePlannerCommentTemplate: { id: string, label: string, body: string, selections: Array<string> } };

export type DeleteKartePlannerCommentTemplateMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteKartePlannerCommentTemplateMutation = { deleteKartePlannerCommentTemplate: Array<{ id: string, label: string, body: string, selections: Array<string> }> };


export const FetchKartePlannerCommentTemplateDocument = gql`
    query FetchKartePlannerCommentTemplate {
  viewer {
    kartePlannerCommentTemplates {
      id
      label
      body
      selections
    }
  }
}
    `;

/**
 * __useFetchKartePlannerCommentTemplateQuery__
 *
 * To run a query within a Vue component, call `useFetchKartePlannerCommentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKartePlannerCommentTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKartePlannerCommentTemplateQuery();
 */
export function useFetchKartePlannerCommentTemplateQuery(options: VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>(FetchKartePlannerCommentTemplateDocument, {}, options);
}
export function useFetchKartePlannerCommentTemplateLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>(FetchKartePlannerCommentTemplateDocument, {}, options);
}
export type FetchKartePlannerCommentTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKartePlannerCommentTemplateQuery, FetchKartePlannerCommentTemplateQueryVariables>;
export const AddKartePlannerCommentTemplateDocument = gql`
    mutation addKartePlannerCommentTemplate($input: AddKartePlannerCommentTemplateInput!) {
  addKartePlannerCommentTemplate(input: $input) {
    id
    label
    body
    selections
  }
}
    `;

/**
 * __useAddKartePlannerCommentTemplateMutation__
 *
 * To run a mutation, you first call `useAddKartePlannerCommentTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddKartePlannerCommentTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddKartePlannerCommentTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddKartePlannerCommentTemplateMutation(options: VueApolloComposable.UseMutationOptions<AddKartePlannerCommentTemplateMutation, AddKartePlannerCommentTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddKartePlannerCommentTemplateMutation, AddKartePlannerCommentTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddKartePlannerCommentTemplateMutation, AddKartePlannerCommentTemplateMutationVariables>(AddKartePlannerCommentTemplateDocument, options);
}
export type AddKartePlannerCommentTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddKartePlannerCommentTemplateMutation, AddKartePlannerCommentTemplateMutationVariables>;
export const UpdateKartePlannerCommentTemplateDocument = gql`
    mutation updateKartePlannerCommentTemplate($input: UpdateKartePlannerCommentTemplateInput!) {
  updateKartePlannerCommentTemplate(input: $input) {
    id
    label
    body
    selections
  }
}
    `;

/**
 * __useUpdateKartePlannerCommentTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateKartePlannerCommentTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKartePlannerCommentTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateKartePlannerCommentTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKartePlannerCommentTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateKartePlannerCommentTemplateMutation, UpdateKartePlannerCommentTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateKartePlannerCommentTemplateMutation, UpdateKartePlannerCommentTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateKartePlannerCommentTemplateMutation, UpdateKartePlannerCommentTemplateMutationVariables>(UpdateKartePlannerCommentTemplateDocument, options);
}
export type UpdateKartePlannerCommentTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateKartePlannerCommentTemplateMutation, UpdateKartePlannerCommentTemplateMutationVariables>;
export const DeleteKartePlannerCommentTemplateDocument = gql`
    mutation deleteKartePlannerCommentTemplate($id: ID!) {
  deleteKartePlannerCommentTemplate(id: $id) {
    id
    label
    body
    selections
  }
}
    `;

/**
 * __useDeleteKartePlannerCommentTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteKartePlannerCommentTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKartePlannerCommentTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteKartePlannerCommentTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKartePlannerCommentTemplateMutation(options: VueApolloComposable.UseMutationOptions<DeleteKartePlannerCommentTemplateMutation, DeleteKartePlannerCommentTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteKartePlannerCommentTemplateMutation, DeleteKartePlannerCommentTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteKartePlannerCommentTemplateMutation, DeleteKartePlannerCommentTemplateMutationVariables>(DeleteKartePlannerCommentTemplateDocument, options);
}
export type DeleteKartePlannerCommentTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteKartePlannerCommentTemplateMutation, DeleteKartePlannerCommentTemplateMutationVariables>;